document.addEventListener('DOMContentLoaded', initProductAccordions);

function initProductAccordions() {
  let accordions = document.querySelectorAll('.product__accordion details');
  if (accordions && accordions.length) {
    accordions.forEach((accordion) => {
      accordion.addEventListener('click', toggleOthersClosed);
      function toggleOthersClosed() {
        accordions.forEach((item) => {
          if (item != accordion && item.hasAttribute('open')) {
            item.removeAttribute('open');
          }
        });
      }
    });
  }
}
